<!-- end background header -->
<div class="row">
  <div class="col-md-12">
    <div class="background-header">
      <div id="myCarousel" class="carousel slide" data-ride="carousel">

        <!-- end indicators -->
        <div class="carousel-inner">
          <div *ngFor="let banner of banners" class="{{banner?.style}}">
            <!--Caption here -->
            <!-- <div class="carousel-caption">
              <p>
                <a>{{banner.title}}</a>
              </p>
            </div> -->
            <!-- end caption -->
            <img class="d-block w-100 img-slide" src="{{banner?.pathimage}}" alt="Black Cat" />
          </div>

          <!-- Controls -->
          <a class="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#myCarousel" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- <div class="row bg-main no-gutter justify-content-center row-title">
  <div class="col-md-12 p-0 contain-main-menu">
    <div class="container text-center">
      <div class="text-title">
        <h2>
          VÌ SAO <span style="font-size: 120%;">20.000</span> SINH VIÊN CHỌN KẾ
          TOÁN - TÀI CHÍNH
        </h2>
      </div>
      <div class="row text-center">
        <div
          class="col-md-2 col-sm-4 col-xs-6 col-md-offset-1 text-center col-pr"
        >
          <p class="big">5★</p>
          <p class="text-top-small">CHẤT LƯỢNG<br />ĐÀO TẠO</p>
        </div>
        <div class="col-md-2 col-sm-4 col-xs-6 text-center col-pr">
          <p class="big"><span>TOP</span> 2</p>
          <p class="text-top-small">
            QUẢN TRỊ KINH DOANH<br />TỐT NHẤT VIỆT NAM
          </p>
        </div>
        <div class="col-md-2 col-sm-4 col-xs-6 text-center col-pr">
          <p class="big">98%</p>
          <p class="text-top-small">SINH VIÊN CÓ<br />VIỆC LÀM NGAY</p>
        </div>
        <div class="col-md-2 col-sm-6 col-xs-6 text-center col-pr">
          <p class="big">19%</p>
          <p class="text-top-small">Sinh viên có việc làm tại nước ngoài</p>
        </div>
        <div class="col-md-2 col-sm-6 col-xs-6 text-center col-pr">
          <p class="big">100%</p>
          <p class="text-top-small">Giảng viên có trình độ Thạc sĩ trở lên</p>
        </div>
        <div class="col-md-2 col-sm-6 col-xs-12 text-center col-pr">
          <p class="big">8,3 triệu</p>
          <p class="text-top-small">LÀ MỨC LƯƠNG<br />TRUNG BÌNH</p>
        </div>
      </div>
    </div>
  </div>
</div> -->
<!-- end background header -->
<div class="container-large">
  <div class="title-main">
    <h3>Giới thiệu</h3>
  </div>
  <div class="row mt-30">
    <div class="col-md-12 col-sm-12 col-12 col-education">
      <div class="serv-section-2">
        <div class="serv-section-2-icon"><i class="fas fa-sitemap"></i></div>
        <div class="serv-section-desc" [innerHTML]="footer?.aboutMain">

        </div>
        <div class="section-heading-line-left"></div>
      </div>
    </div>
    <!-- <div class="col-md-6 col-sm-12 col-12 ">
            <div class="serv-section-2 serv-section-2-act">
                <div class="serv-section-2-icon serv-section-2-icon-act"> <i class="fas fa-university"></i> </div>
                <div class="serv-section-desc">
                    <h4>Ngân hàng</h4>
                    <p>Mục tiêu đào tạo: Đào tạo cử nhân có kiến thức chuyên sâu về tiền tệ – ngân hàng, tập trung vào
                        các nghiệp vụ của ngân hàng thương mại và phân tích, đầu tư chứng khoán.</p>
                </div>
                <div class="section-heading-line-left"></div>

            </div>
        </div> -->
  </div>
</div>
<div class="container-large">
  <!----------------------------------- Tin mới  -------------------------->

  <div class="row">
    <div class="col-md-12">
      <div class="title-main">
        <h3>Tin tức</h3>
      </div>
    </div>
    <div class="col-md-8">
      <div class="row">
        <div class="col-md-6" *ngFor="let focusNew of focusNews">
          <div class="post-slide">
            <div class="post-img">
              <img *ngIf="focusNew?.pathimage!=''" src="{{ focusNew?.pathimage }}" alt="{{focusNew?.title}}" />
              <img *ngIf="focusNew?.pathimage==''" src="/assets/img/noimage-1.png" alt="{{focusNew?.title}}" />
            </div>
            <h3 class="post-title">
              <a (click)="onNewsClick(focusNew)">
                {{ focusNew?.title | slice: 0:50 }}...</a>
              <div class="date">
                <i class="fa fa-clock-o mr-2" aria-hidden="true"></i>

                <span class="date-detail">
                  {{ focusNew?.postdate | date: "short" }}</span>
                <i class="fa fa-eye mr-2" aria-hidden="true"></i>
                <span>{{ focusNew?.view }}</span>
              </div>
            </h3>

            <p class="post-description">
              {{ focusNew?.summary | slice: 0:110 }}..
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-news">
      <div class="news-title" *ngFor="let focusNew1 of focusNewsRight" (click)="onNewsClick(focusNew1)">
        <h5>
          {{ focusNew1?.title }} <i class="fas fa-angle-double-right ml-1"></i>
        </h5>
        <div class="date">
          <i class="fa fa-clock-o mr-2" aria-hidden="true"></i>

          <span class="date-detail">
            {{ focusNew1?.postdate | date: "short" }}</span>
          <i class="fa fa-eye mr-2" aria-hidden="true"></i>
          <span>{{ focusNew1?.view }}</span>
        </div>
      </div>
    </div>
  </div>
  <!----------------------------------- End Tin mới  -------------------------->

  <!----------------------------------- Sự kiện  -------------------------->
  <div class="row">
    <div class="col-md-12">
      <div class="title-main">
        <h3>Nghiên cứu khoa học</h3>
      </div>
    </div>
    <div class="col-md-4" *ngFor="let event of events">
      <div class="card border-0 shadow card-event" (click)="onTitleClick(event)">
        <img *ngIf="event?.pathimage!=''" src="{{ event?.pathimage }}" class="card-img-top" />
        <img *ngIf="event?.pathimage==''" src="/assets/img/noimage-1.png" class="card-img-top" />
        <div class="card-body text-left card-event-text">
          <h5 class="card-title mb-0">{{ event?.title | slice: 0:60 }}...</h5>
          <div class="card-text text-black-50">
            <div class="date">
              <i class="fa fa-clock-o mr-2" aria-hidden="true"></i>

              <span class="date-detail">
                {{ event?.postdate | date: "short" }}</span>
              <i class="fa fa-eye mr-2" aria-hidden="true"></i>
              <span>{{ event?.view }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!----------------------------------- End Sự kiện  -------------------------->

  <!----------------------------------- Đánh giá -------------------------->
  <div class="row mt-4">
    <div class="col-md-6">
      <!-- Video -->
      <div class="embed-responsive embed-responsive-16by9 mb-4" [innerHTML]="video">

      </div>
    </div>
    <div class="col-md-6">
      <div id="testimonial-slider" class="owl-carousel">
        <div class="testimonial">
          <p class="description" [innerHTML]="footer.about">
          </p>
        </div>
      </div>
    </div>

    <!-- Liên kêt -->
    <div *ngIf="bannersLink?.length>0 || bannersMobile?.length>0" class="col-lg-12 col-md-12 col-sm-12 p-0 mt-0">
      <h4 class="h4-link">{{text_link}}</h4>
      <div *ngIf="!isMobile" id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
        <div class="carousel-inner">
          <div class="carousel-item " [ngClass]="{'active': slideItem?.active}" *ngFor="let slideItem of bannersLink">
            <div class="row" *ngFor="let rowSlide of slideItem?.rowSlide">
              <div class="col-md-3 col-xs-3 col-6" *ngFor="let colSlide of rowSlide">
                <a [title]="colSlide?.title" [href]="colSlide?.link" target="_blank" class="thumbnail"><img
                    src="{{colSlide?.pathimage}}" alt="{{colSlide?.title}}" class="img-slider"></a>
              </div>

            </div>

          </div>
          <!-- Controls -->
          <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
      <div *ngIf="isMobile" id="carouselExampleIndicatorsMobile" class="carousel slide" data-ride="carousel">
        <div class="carousel-inner">
          <div class="{{bannerMobile?.style}}" *ngFor="let bannerMobile of bannersMobile">
            <div class="row">
              <div class="col-12">
                <a [title]="bannerMobile?.title" [href]="bannerMobile?.link" target="_blank" class="thumbnail"><img
                    src="{{bannerMobile?.pathimage}}" alt="{{bannerMobile?.title}}" class="img-slider"></a>
              </div>

            </div>

          </div>
          <!-- Controls -->
          <a class="carousel-control-prev" href="#carouselExampleIndicatorsMobile" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#carouselExampleIndicatorsMobile" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<!----------------------------------- End Đánh giá -------------------------->